const convertToMegaBytes = (bytes) => bytes / 1024;

export { convertToMegaBytes };
